/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_More_Stats_Stopped_LabelInputs */

const en_ui_more_stats_stopped_label = /** @type {(inputs: Ui_More_Stats_Stopped_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stopped`)
};

const de_ui_more_stats_stopped_label = /** @type {(inputs: Ui_More_Stats_Stopped_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standzeit`)
};

/**
* | output |
* | --- |
* | "Stopped" |
*
* @param {Ui_More_Stats_Stopped_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_more_stats_stopped_label = /** @type {((inputs?: Ui_More_Stats_Stopped_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_More_Stats_Stopped_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_more_stats_stopped_label(inputs)
	return de_ui_more_stats_stopped_label(inputs)
});